import { IConfiguration } from "@app/config/getConfig.interfaces";

const ProductionConfig: Omit<IConfiguration, "supportedBrackets"> = {
  environment: "production",
  urls: {
    requestQuote: "/api/v1/requestQuote",
    systemLoads: "/api/v1/systemLoads",
    estimateProduction: "/api/v1/estimateProduction",
    webshopOrder: "/api/v1/webshopOrder",
    electricalDesign: "/api/v1/electricalDesign",
    submitLead: "/api/v1/submitLead",
    token: "/api/v1/token",
    app: "https://app.raulibrackets.fi",
    admin: {
      users: "/api/v1/admin/users",
      prices: "/api/v1/admin/prices/update",
    },
  },
  recatchaSiteKey: "6LeIVg8sAAAAAGhKTOCy-Xui-BtYJmaCwzkWlcYe",
  mapsToken: "AIzaSyAw5eqiIbzCo_KzcbiUVpCILP1LTNKKM8w",
  firebase: {
    apiKey: "AIzaSyA9hH1lDwCvRh9F01WYw_22s5x9XsIN98Q",
    authDomain: "raulibrackets.firebaseapp.com",
    projectId: "raulibrackets",
    storageBucket: "raulibrackets.appspot.com",
    messagingSenderId: "729247532560",
    appId: "1:729247532560:web:e00e437b8d32e14b2d2c95",
  },
  load: {
    maximumSnowLoad: 5000,
    maximumWindLoad: 2000,
  },
  panel: {
    width: {
      min: 900,
      max: 1400,
    },
    height: {
      min: 1600,
      max: 2400,
    },
  },
  flat: {
    doublePanelGap: 40,
    tilt: {
      landscape: 13,
      portrait: 10,
    },
  },
  version: process.env.REACT_APP_CI_COMMIT_TAG ?? "production",
  wall: {
    railWidth: 3000,
    railGapWidth: 100,
    screwSpacing: {
      wood: 400,
      concrete: 1000,
      other: 300,
    },
    verticalBeam: {
      spacing: 1500,
      offsets: [-200, 200],
    },
  },
  nova: { railSku: "32001", minimumRailLength: 500, maxBracketSpacing: 800 },
  componentRoundingPercentage: 50,
};

export default ProductionConfig;
